import { DatePicker, DatePickerProps, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';

interface IDateInput extends DatePickerProps<Dayjs> {
  setFieldValue: (name: string, date: any) => void;
  minDate?: any;
  name: string;
  error?: any;
  disableFuture?: boolean;
  value: any;
  label?: string;
  shouldDisableDate?: (date: any) => boolean;
  defaultCalendarMonth?: any;
  disablePast?: boolean;
  hide?: boolean;
  inputId?: string;
  disabled?: boolean;
}

const sx = {
  dateInput: {
    '& .MuiInputBase-root': {
      borderRadius: '1rem',
    },
  },
};

export function DateInput({
  value,
  label,
  error,
  name,
  setFieldValue,
  minDate,
  disableFuture,
  shouldDisableDate,
  defaultCalendarMonth,
  disablePast = false,
  hide = false,
  inputId,
  disabled = false,
  ...props
}: IDateInput) {
  if (hide) {
    return null;
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        disableFuture={disableFuture}
        disablePast={disablePast}
        minDate={minDate}
        value={value ? dayjs(value) : null}
        format="YYYY-MM-DD"
        name={name}
        sx={sx.dateInput}
        disabled={disabled}
        onChange={(date) => {
          setFieldValue(name, date);
        }}
        slotProps={{
          inputAdornment: {
            position: `start`,
          },
          field: {
            id: inputId,
          },
          textField: {
            error: !!error,
            helperText: error,
            sx: sx.dateInput,
          },
        }}
        shouldDisableDate={shouldDisableDate}
        referenceDate={defaultCalendarMonth}
        {...props}
      />
    </LocalizationProvider>
  );
}
